<div class="search-wrapper">
    <input
        #searchInput
        type="text"
        [formControl]="query"
        [placeholder]="query.value ? '' : getSearchPlaceholder()"
        (keydown.enter)="navigateToMarkedItem()"
        (keydown.arrowUp)="markPrevious()"
        (keydown.arrowDown)="markNext()"
        (keydown.escape)="resetQuery()"
        (focusout)="focusOut()"
        (focus)="focus()"
    />

    <!-- searching inactive -->
    @if (!query.value) {
        <div class="suffix-wrapper">
            <mat-icon>search</mat-icon>
        </div>
    } @else {
        <!-- close button or loading -->
        @if (isLoading) {
            <places-spinner small="true"></places-spinner>
        } @else {
            <div class="suffix-wrapper close-button" (click)="resetQuery(); searchInput.focus()">
                <i class="fa-solid fa-circle-xmark"></i>
            </div>
        }
    }

    <!-- searching active -->
</div>
@if (showSearchResults) {
    <div
        class="search-result add-shadow"
        (mouseenter)="delayFocusOut()"
        (touchstart)="delayFocusOut()"
    >
        <ul>
            @if (!isBackendLoading) {
                <ng-container appScrollSpy querySelector=".scrollable">
                    @for (item of listResult; track item) {
                        <li
                            (click)="navigateToItem(item)"
                            [ngClass]="{ marked: markedItem === item }"
                            class="scrollable"
                            [attr.id]="'i' + item.scrollableId"
                        >
                            <div class="header">
                                <div class="title">
                                    @if (item.iconClass) {
                                        <i
                                            class="icon"
                                            [ngClass]="item.iconClass"
                                        ></i>
                                    }
                                    <span [innerHTML]="item.title"></span>
                                </div>
                                <div class="sub-title">{{ item.subTitle }}</div>
                            </div>
                            <div class="status">
                                <div class="cirlce"></div>
                            </div>
                        </li>
                    }
                </ng-container>
            } @else {
                <div>
                    <div class="header">
                        <div class="title d-flex align-items-center p-4">
                            <places-spinner small="true"></places-spinner>
                            <span class="ml-2" translate>Searching deeper</span>
                        </div>
                    </div>
                </div>
            }
        </ul>
    </div>
}
